export default __webpack_public_path__ + "static/media/stars_bg.c8442773.png";